<template>
  <div>
    <v-container>
        <v-switch label="Vos" v-model="settings.fox" @change="changeFoxSetting"></v-switch>
        <v-switch label="Vos Cirkel" v-model="settings.foxCircle" @change="changeFoxCircleSetting"></v-switch>
        <v-switch label="Vos Pad" v-model="settings.foxPath" @change="changeFoxPathSetting"></v-switch>
        <!-- <v-switch label="Auto's" v-model="settings.cars" @change="changeCarsSetting"></v-switch> -->
        <v-switch label="Honken" v-model="settings.groups" @change="changeGroupsSetting"></v-switch>
        <v-switch label="Honk cirkel" v-model="settings.baseCircle" @change="changeBaseCircleSetting"></v-switch>
        <v-switch label="Deelgebieden" v-model="settings.zones" @change="changeZonesSetting"></v-switch>
        <v-switch label="Point of Interest" v-model="settings.pois" @change="changePoisSetting"></v-switch>
    </v-container>
  </div>
</template>

<script>

export default {
  name: 'settings',
  computed: {
      settings() {
          return this.$store.getters.settings;
      }
  },
  methods: {
      changeFoxSetting(e) {
          this.$store.commit('SET_SETTING_FOX', e)
      },
      changeFoxCircleSetting(e) {
          this.$store.commit('SET_SETTING_FOX_CIRCLE', e)
      },
      changeFoxPathSetting(e) {
          this.$store.commit('SET_SETTING_FOX_PATH', e)
      },
      changeCarsSetting(e) {
          this.$store.commit('SET_SETTING_CARS', e)
      },
      changeGroupsSetting(e) {
          this.$store.commit('SET_SETTING_GROUPS', e)
      },
      changeZonesSetting(e) {
          this.$store.commit('SET_SETTING_ZONES', e)
      },
      changePoisSetting(e) {
          this.$store.commit('SET_SETTING_POIS', e)
      },
      changeBaseCircleSetting(e) {
          this.$store.commit('SET_SETTING_BASE_CIRCLE', e);
      }
  }
}
</script>





// WEBPACK FOOTER //
// src/components/Settings.vue